import React from 'react'
import CouponConfigurableLabel from '../../../manageCoupons/components/CouponConfigurableLabel';
import IncentiveRadioField from './IncentiveRadioField';
import { Stack } from '@mui/material';
import '../../Incentive.css'


export const IncentiveRadioSelector = (props: any) => {
    const { options, selectedValue, handleChange, direction = "row", disable = false } = props;
    return (
        <div className="incentive-radio-selector-wrapper">
            <Stack direction={direction} gap={'30px'} justifyContent={"flex-start"} flexWrap={'wrap'}>
                {
                    options?.map((option: { value: string, description?: string }) => {
                        const checked = option.value === selectedValue;
                        return (
                            <IncentiveRadioField
                                key={option.value}
                                label={<CouponConfigurableLabel text={option.value} style={{ cursor: 'inherit',  color:/* disable ? 'grey' : */ 'grey' }} />}
                                value={option.value}
                                description={option.description}
                                checked={checked}
                                handleChange={disable ? undefined : handleChange} // Disable handleChange if disable is true
                                disabled={disable} // Pass the disable prop to the field
                            />
                        )
                    })
                }
            </Stack>
        </div>
    );
}
